import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {RequestsGridComponent} from '../../components/Requests/RequestsGrid.component';

@Component({
  selector: 'my-fullservicepricingrequests',
  templateUrl: './FullServicePricingRequests.component.html'
})
export class FullServicePricingRequestsComponent implements OnInit {

    @ViewChild(RequestsGridComponent) requestsGridComponent: RequestsGridComponent;

    public noExistingRequests: boolean;
    userInfo: ent.UserInfo;

    options: any;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private router: Router) 
    {
        
        
    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
        //this.requestsGridComponent.requestStatusMultiSelectComponent.selectedIDs = [];
        this.requestsGridComponent.requestStatusIDsToSelectOnLoad = [enums.RequestStatusEnum.Open, enums.RequestStatusEnum.Submitted, enums.RequestStatusEnum.Rejected, enums.RequestStatusEnum.Emailed];

        this.requestsGridComponent.requestTypeIDsToSelectOnLoad = [enums.RequestTypeEnum.FullServicePricing];

        this.requestsGridComponent.employeeIDsToSelectOnLoad = [this.userInfo.Employee.ID];
        
        this.requestsGridComponent.salesOfficeIDsToSelectOnLoad = [this.userInfo.Employee.SalesOfficeID];

        this.requestsGridComponent.showCustomerColumns = false;

        this.requestsGridComponent.showFSPCustomerColumns = true;

        Promise.all([
            this.requestsGridComponent.loadEmployees(),
            this.requestsGridComponent.loadRequestStatuses(),
            this.requestsGridComponent.loadRequestTypes(),
            this.requestsGridComponent.loadSalesOffices()
          ]).then(value => {
                this.requestsGridComponent.onSearchClick(null);
                this.requestsGridComponent.updateRequests.subscribe((x: boolean)=>this.onUpdateRequests(x));
          });

    }

    onUpdateRequests(x: boolean){

        this.requestsGridComponent.onSearchClick(null);

        
    }
}